import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// NG-ZORRO modules used by this module's OWN declarations only. Deliberately not
// re-exported: SharedModule is imported by the eager AppModule, so anything listed
// here lands in the initial bundle for every visitor. Consumers import the zorro
// modules they need themselves, which keeps them inside their lazy chunk.
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';

// Shared Components
import { NzDateRangePickerComponent } from './components/nz-date-range-picker/nz-date-range-picker.component';
import { InputSearchComponent } from './components/input-search/input-search.component';
import { LoadingComponent } from './components/loading/loading.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { QueryVariablesComponent } from './components/query-variables/query-variables.component';
import { BreadcrumbComponent } from '../layouts/breadcrumb/breadcrumb.component';
// Shared Pipes
import { SafeUrlPipe } from './pipe/safe-url.pipe';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';

// Shared Directives
import { OnlyNumberDirective } from './directives/only-number.directive';
import { MoneyFormatDirective } from './directives/money-format.directive';
import { ScrollFadeDirective } from './directives/scroll-fade.directive';

const NZ_MODULES = [
    NzBreadCrumbModule,
    NzButtonModule,
    NzIconModule,
    NzInputModule,
    NzRadioModule,
    NzSpinModule,
    NzDatePickerModule,
];

const SHARED_COMPONENTS = [
    NzDateRangePickerComponent,
    InputSearchComponent,
    LoadingComponent,
    PaginatorComponent,
    QueryVariablesComponent,
    BreadcrumbComponent,
];

@NgModule({
    declarations: [
        ...SHARED_COMPONENTS,
        SafeUrlPipe,
        SafeHtmlPipe,
        OnlyNumberDirective,
        MoneyFormatDirective,
        ScrollFadeDirective,
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule,
        ...NZ_MODULES,
    ],
    exports: [
        CommonModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule,
        ...SHARED_COMPONENTS,
        SafeUrlPipe,
        SafeHtmlPipe,
        OnlyNumberDirective,
        MoneyFormatDirective,
        ScrollFadeDirective,
    ],
    providers: [],
})
export class SharedModule {
}
